import type { ReactNode } from "react";

/**
 * The page title block.
 *
 * `trailing` holds filters, a clock, or a status — NOT a primary action. Create
 * actions belong inline in the first card of the page, beside the thing being
 * created, rather than as a floating button in the corner. That is a deliberate
 * pattern, not an omission.
 */
export function PageHeader({
  title,
  subtitle,
  eyebrow,
  leading,
  trailing,
}: {
  title: string;
  subtitle?: string;
  /** Small label above the title — the dashboard uses it for the business name. */
  eyebrow?: string;
  leading?: ReactNode;
  trailing?: ReactNode;
}) {
  return (
    <div className="flex items-start justify-between gap-3">
      <div className="flex items-center gap-3">
        {leading}
        <div>
          {eyebrow && <div className="text-xs font-medium text-muted-subtle">{eyebrow}</div>}
          <h1 className="text-xl font-semibold text-ink-900">{title}</h1>
          {subtitle && <p className="mt-0.5 text-sm text-muted-foreground">{subtitle}</p>}
        </div>
      </div>
      {trailing}
    </div>
  );
}
